module.exports = __webpack_public_path__ + "img/left.a4d63fc1.png";